// Keeps one batch well under the 64 KiB fetch({ keepalive: true }) body limit.
export const MATERIAL_CARD_IMPRESSION_BUFFER_LIMIT = 40;

// IAB viewability: >=50% of the element visible for >=1s. Higher ratios are unreachable for
// cards taller than the viewport (e.g. MaterialBigPreview on mobile).
export const IMPRESSION_VISIBILITY_THRESHOLD = 0.5;
export const IMPRESSION_DWELL_TIME_MS = 1000;
